import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export const AddRMForm = ({ onCreated }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/rms/create", { name, email, whatsapp });
      toast.success(data.welcome_email_sent
        ? `RM created — welcome email with temporary password sent to ${data.email}`
        : "RM created, but the welcome email failed — check the Email Log");
      setName(""); setEmail(""); setWhatsapp(""); setOpen(false);
      onCreated?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't create the RM");
    }
    setBusy(false);
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)}
        className="flex items-center gap-1.5 rounded-lg bg-[#0A8B85] px-3 py-2 text-xs font-bold text-white hover:bg-[#087a74]"
        data-testid="admin-add-rm-btn">
        <UserPlus size={14} /> Add RM
      </button>
    );
  }
  return (
    <div className="mt-3 w-full rounded-2xl border border-neutral-800 bg-neutral-950 p-4" data-testid="admin-add-rm-form">
      <p className="text-sm font-bold text-neutral-200">New Relationship Manager</p>
      <p className="mt-0.5 text-[11px] text-neutral-500">
        A secure temporary password is auto-generated and emailed from noreply@clinq.africa — they'll be forced to change it on first sign-in.
      </p>
      <div className="mt-3 grid gap-3 sm:grid-cols-3">
        <label className="block">
          <span className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-neutral-400">Full name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Wairimu Ndiritu"
            className="w-full rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 text-xs text-neutral-100 outline-none focus:border-[#0A8B85]"
            data-testid="admin-add-rm-name" />
        </label>
        <label className="block">
          <span className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-neutral-400">Email address <span className="text-[#2dd4bf]">*</span></span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@clinq.africa"
            className="w-full rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 text-xs text-neutral-100 outline-none focus:border-[#0A8B85]"
            data-testid="admin-add-rm-email" />
          <span className="mt-1 block text-[10px] text-neutral-500">Login + welcome email with temporary password go here</span>
        </label>
        <label className="block">
          <span className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-neutral-400">WhatsApp (optional)</span>
          <input value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} placeholder="+254 7xx xxx xxx"
            className="w-full rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 text-xs text-neutral-100 outline-none focus:border-[#0A8B85]"
            data-testid="admin-add-rm-whatsapp" />
        </label>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={submit} disabled={busy || !name.trim() || !email.includes("@")}
          className="rounded-lg bg-[#0A8B85] px-4 py-2 text-xs font-bold text-white hover:bg-[#087a74] disabled:opacity-40"
          data-testid="admin-add-rm-submit">
          {busy ? "Creating…" : "Create & send welcome email"}
        </button>
        <button onClick={() => setOpen(false)}
          className="rounded-lg border border-neutral-700 px-3 py-2 text-xs font-semibold text-neutral-400">
          Cancel
        </button>
      </div>
    </div>
  );
};
